import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { htmlSubstring } from '@core/helpers/html-substring';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Text as TextContent } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import striptags from 'striptags';
import {
  AccountService,
  AuthService,
  ContentService,
  ContextService,
  FeaturesService,
  MetaService,
  PlatformService,
  RequestService,
} from '../../../core/services/';
import { BaseContentCard, IContentCardState } from '../base-content-card';

interface IArticleCardState extends IContentCardState {
  modalOpened: boolean;
  expanded: boolean;
}

const allowedTags = [
  'br',
  'strong',
  'b',
  'em',
  'i',
  's',
  'strike',
  'span',
  'h1',
  'h2',
  'h3',
  'h4',
  'p',
  'div',
  'table',
  'tbody',
  'thead',
  'tr',
  'td',
  'th',
  'caption',
  'ol',
  'ul',
  'li',
  'img',
  'figure',
  'figcaption',
  'marker', // маркер
  // 'gap', 'gapoption', // пропуск в тексте
  'blockquote',
  'hr',
];

@Component({
  selector: 'app-article-card',
  templateUrl: './article-card.component.html',
  styleUrls: ['./article-card.component.scss'],
})
export class ArticleCardComponent extends BaseContentCard implements OnDestroy {
  @Input() set expanded(expanded: boolean) {
    this.state.expanded = expanded;
  }
  public state: IArticleCardState = {
    ...super.getState(),
    expanded: true,
    modalOpened: false,
  };
  protected cutMaxLength = 200;
  protected _item: TextContent;
  protected _textFull: string;
  protected _textCut: string;

  constructor(
    protected accountService: AccountService,
    protected contextService: ContextService,
    protected contentService: ContentService,
    protected authService: AuthService,
    protected features: FeaturesService,
    protected router: Router,
    protected metaService: MetaService,
    protected translate: TranslateService,
    protected location: Location,
    protected readonly request: RequestService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
    public deviceService: DeviceDetectorService,
    public store: Store,
  ) {
    super(
      accountService,
      contextService,
      contentService,
      authService,
      features,
      router,
      metaService,
      translate,
      location,
      request,
      cdr,
      platform,
      store,
    );
  }

  public onExpandText() {
    this.state.cut = false;
    this.markForCheck();
  }

  public get text(): string {
    return this.isBrowser && this.state.cut ? this._textCut : this._textFull;
  }

  protected init() {
    super.init();
    this._textFull = (this.item as TextContent).text || '';
    this._textCut =
      striptags(this._textFull).length > this.cutMaxLength
        ? htmlSubstring(this._textFull, this.cutMaxLength, allowedTags)
        : this._textFull;
    this.markForCheck();
  }
}
